module.exports = __webpack_public_path__ + "img/c08_unitpalintonon_Normal_ua.dcba0f6d.webp";